import { useEffect } from "react";
import AdstraBanner from "@/components/AdstraBanner";

const AdRedirect = () => {
  useEffect(() => {
    // Auto-close the ad page after 5 seconds (optional)
    const timer = setTimeout(() => {
      window.close();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold mb-2">Advertisement</h1>
        <p className="text-muted-foreground mb-4">
          This window will close automatically in 5 seconds
        </p>
        <button
          onClick={() => window.close()}
          className="text-primary hover:underline text-sm"
        >
          Close this window
        </button>
      </div>
      
      <AdstraBanner />
      
      <div className="mt-8 text-center text-sm text-muted-foreground">
        <p>Thank you for supporting our content!</p>
      </div>
    </div>
  );
};

export default AdRedirect;
